<template>
  <div class="is-loading d-flex justify-content-center align-items-center">
    <!-- <img width="60px" :src="loading_gif"  alt="Loading..."> -->
    <!-- 7 --> 
    <div class="loader loader--style6" title="5" style="width:60px; height:60px">
      <span class="spinner"  ></span>
    </div>
  </div>
</template>


<script>
// import loading_gif from "../assets/global_assets/images/loading.gif";
export default {
  name: "BaseLoading",
  data() {
    return {
      // loading_gif: loading_gif,
    };
  },
};
</script>


<style lang="scss">
/* Loader */
.spinner {
    height: 60px;
    width: 60px;
    margin: auto;
    display: flex;
    position: absolute;
    -webkit-animation: rotation 0.6s infinite linear;
    -moz-animation: rotation 0.6s infinite linear;
    -o-animation: rotation 0.6s infinite linear;
    animation: rotation 0.6s infinite linear;
    border-left: 6px solid rgba(0, 174, 239, 0.15);
    border-right: 6px solid rgba(0, 174, 239, 0.15);
    border-bottom: 6px solid rgba(0, 174, 239, 0.15);
    border-top: 6px solid rgba(0, 174, 239, 0.8);
    border-radius: 100%;
  }
  
  @-webkit-keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(359deg);
    }
  }
  
  @-moz-keyframes rotation {
    from {
      -moz-transform: rotate(0deg);
    }
    to {
      -moz-transform: rotate(359deg);
    }
  }
  
  @-o-keyframes rotation {
    from {
      -o-transform: rotate(0deg);
    }
    to {
      -o-transform: rotate(359deg);
    }
  }
  
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
  
  #overlay {
    position: fixed;
    display: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2;
    cursor: pointer;
  }
  
  #overlay.show {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
  /* 
    #overlay.hide {
      display: -webkit-box!important;
      display: -ms-flexbox!important;
      display: flex!important;
    } */
  /* End loader */
  
</style>
